import styled from "styled-components";
import { media } from "../../../../../components/common/media";

const ContactContainer = styled.section`
  background: #ececec;
  padding: 60px 0 70px;

  .need-help-container {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;

    h4 {
      margin-top: 27px;

      span {
        font-size: 24px;
        color: #fff;
        font-weight: 900;
        background: ${props => props.theme.colorFlamingo};
        text-transform: uppercase;
        letter-spacing: 1px;
        padding: 10px 55px;

        a {
          color: #fff;
        }
      }
    }

    .send-us-message {
      ${media.tablet`
        margin-top: 20px;
      `};

      p {
        font-size: 18px;
        font-weight: 400;
        line-height: 200%;
        color: #000;
        margin: 0;

        a {
          color: ${props => props.theme.colorFlamingo};
          text-decoration: underline;
          font-size: 20px;
          font-weight: 400;
          transition: all 0.6s ease 0s;
        }

        span {
          padding: 0 20px;
        }
      }
    }
  }
`;

export default ContactContainer;
